<script setup>
import { computed, onMounted, onUnmounted } from 'vue'

import { confirmState } from '@/components/modal/confirmHelper'
import ImoModal from '@/components/modal/ImoModal_.vue'

const options = computed(() => confirmState.options)

const variantIcon = computed(() => {
  const map = {
    danger: { name: 'close-circle', class: 'text-error-60' },
    warning: { name: 'warning-2', class: 'text-warning-60' },
    info: { name: 'info-circle', class: 'text-info-70' },
    success: { name: 'tick-circle', class: 'text-success-70' },
  }
  return map[options.value.variant] ?? map['info']
})

const confirmLabel = computed(() => options.value.confirmLabel ?? 'Confirmar')
const cancelLabel = computed(() => options.value.cancelLabel ?? 'Cancelar')
const extraActionLabel = computed(() => options.value.extraActionLabel ?? '')
const extraActionVariant = computed(() => options.value.extraActionVariant ?? 'secondary')

const resolve = value => {
  if (confirmState.resolve) {
    confirmState.resolve(value)
    confirmState.resolve = null
  }
  confirmState.show = false
}

const onConfirm = () => resolve(options.value.confirmValue ?? true)
const onCancel = () => resolve(options.value.cancelValue ?? false)
const onExtraAction = () => resolve(options.value.extraActionValue ?? 'extra')

// Fechar com Escape
const onKeydown = e => {
  if (e.key === 'Escape' && confirmState.show) onCancel()
}
onMounted(() => {
  confirmState.mounted = true
  document.addEventListener('keydown', onKeydown)
})
onUnmounted(() => {
  confirmState.mounted = false
  document.removeEventListener('keydown', onKeydown)
})
</script>

<template>
  <ImoModal
    v-model="confirmState.show"
    size="sm"
    :show-header="false"
    :show-footer="false"
    :close-on-backdrop="false"
    @close="onCancel"
  >
    <template #body>
      <div class="flex w-full flex-col items-center gap-6 p-6 text-center">
        <div class="flex w-full justify-end">
          <ImoIcon @click="onCancel" name="close" thickness="0.5" class="cursor-pointer" />
        </div>
        <!-- Ícone de variante -->
        <ImoIcon :name="variantIcon.name" :size="100" thickness="0.5" :class="variantIcon.class" />

        <!-- Título -->
        <div class="flex flex-col gap-2">
          <h3 class="text-primary-90 text-[22px] font-medium">
            {{ options.title }}
          </h3>
          <p v-if="options.message" class="text-neutral-60 text-base">
            {{ options.message }}
          </p>
        </div>

        <!-- Botões -->
        <div class="flex w-full flex-col-reverse gap-4 sm:flex-row">
          <ImoButton
            v-if="!options.hideCancelButton"
            class="flex-1 whitespace-nowrap"
            :text="cancelLabel"
            variant="tertiary"
            @click="onCancel"
          />
          <ImoButton
            v-if="extraActionLabel"
            class="flex-1 whitespace-nowrap"
            :text="extraActionLabel"
            :variant="extraActionVariant"
            @click="onExtraAction"
          />
          <ImoButton class="flex-1 whitespace-nowrap" :text="confirmLabel" @click="onConfirm" />
        </div>
      </div>
    </template>
  </ImoModal>
</template>
